import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import MainDashboard from './pages/main-dashboard';
import RolePlaybookHub from './pages/role-playbook-hub';
import StartHereHub from './pages/start-here-hub';
import LoginAuthentication from './pages/login-authentication';
import ToolsAndAccessHub from './pages/tools-and-access-hub';
import PublicLandingPage from './pages/public-landing-page';
import CultureAndRitualsHub from './pages/culture-and-rituals-hub';
import EnterpriseLandingPage from './pages/enterprise-landing-page';
import IntegrationsMarketplace from './pages/integrations-marketplace';
import EnterpriseFooterHub from './pages/enterprise-footer-hub';

function AppRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<EnterpriseLandingPage />} />
          <Route path="/main-dashboard" element={<MainDashboard />} />
          <Route path="/role-playbook-hub" element={<RolePlaybookHub />} />
          <Route path="/start-here-hub" element={<StartHereHub />} />
          <Route path="/login-authentication" element={<LoginAuthentication />} />
          <Route path="/tools-and-access-hub" element={<ToolsAndAccessHub />} />
          <Route path="/public-landing-page" element={<PublicLandingPage />} />
          <Route path="/culture-and-rituals-hub" element={<CultureAndRitualsHub />} />
          <Route path="/enterprise-landing-page" element={<EnterpriseLandingPage />} />
          <Route path="/integrations-marketplace" element={<IntegrationsMarketplace />} />
          <Route path="/enterprise-footer-hub" element={<EnterpriseFooterHub />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default AppRoutes;